import {useEffect} from 'react';
import PulsoidClient from './PulsoidClient';
import {useLocation} from 'react-router';
import {usePostHog} from 'posthog-js/react';

export const PosthogInit = () => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog && posthogEnabled()) {
      posthog.init('phc_Ek30nj5OSQBZQ6HsyNTyPw7qnKreSPW5qKc20XpRxsg', {
        api_host: 'https://us.i.posthog.com',
        capture_pageview: false,
      });
      new PulsoidClient({
        noAuthRedirect: true,
      })
        .getUserInfo()
        .then((userInfo) => {
          if (userInfo.id) {
            posthog.identify(userInfo.id);
          }
        })
        .catch(() => {});
    }
  }, [posthog]);

  useEffect(() => {
    if (posthog) {
      if (posthogEnabled()) {
        posthog.capture('$pageview', {
          $current_url: window.location.href,
        });
      }
    }
  }, [location, posthog]);

  return <></>;
};

const posthogEnabled = () => {
  return (
    !window.location.host.includes('127.0.0.1') &&
    !window.location.host.includes('localhost')
  );
};
